var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container bng-virtual-sports bng-narrow-container"},[(_vm.jackpots && _vm.jackpots.length)?_c('jackpots-bar'):_vm._e(),_vm._v(" "),(_vm.games)?_c('game-list',{attrs:{"games":_vm.games}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// c:/Jenkins/workspace/play-at-home-test-frontend-deploy-sites/src/onlinecasino/OnlineCasino.Web.Public/node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!c:/Jenkins/workspace/play-at-home-test-frontend-deploy-sites/src/onlinecasino/OnlineCasino.Web.Public/node_modules/vue-loader/lib??vue-loader-options!./skins/bulmasite/components/pages/sitepages/virtual-sports/virtual-sports.vue?vue&type=template&id=5af1a46b
// module id = iKBV
// module chunks = 0